<template>
  <div class="content">
    <div class="container-fluid">
    
      <router-link
        :to="{ path: '/admin/livraison/createColis' }"
        class="btn btn-round my-3 border-0"
        style="background-color: #ffab0e; color: #fff"
        type="button"
        uk-toggle="target: #create_commande"
        ><i class="fa fa-plus"></i> Créer une commande Express</router-link
      >
      <!-- <router-link
        :to="{ path: '/admin/livraison/create/boutique' }"
        class="btn btn-round my-3 border-0 ml-3"
        style="background-color: #0e76ff; color: #fff"
        type="button"
        uk-toggle="target: #create_commande"
        ><i class="fa fa-plus"></i> Créer une commande Boutique</router-link
      > -->
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="uk-flex uk-flex-between uk-align-center">
                <h4 class="card-title" style="font-weight: bold">
                  Gestions de colis dans Firestore
                </h4>
              </div>
            </template>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="title-tab">#</th>
                  <th scope="col" class="tilte-tab">Noms client</th>
                  <th scope="col" class="tilte-tab">Contact Client</th>
                  <th scope="col" class="tilte-tab">Contact Destinataire</th>
                  <th scope="col" class="tilte-tab">Statut</th>
                  <!-- <th scope="col" class="tilte-tab">Attribué à</th> -->
                  <th scope="col" class="tilte-tab">Valeur colis</th>
                  <th scope="col" class="tilte-tab">Montant</th>
                  <th scope="col" class="tilte-tab">Nature du colis</th>
                  <th scope="col" class="tilte-tab">Date et heure</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(coli, itemObjKey) in Colis"
                  :key="coli.id == 'tyyt'"
                  class="livraison"
                  :class="
                    (coli.statut == 'attente') &
                      (coli.categorie == 'express' || !coli.categorie) ||
                    coli.livreur_id == '3e027c1d-1e14-4097-a263-ce88c1a9915f' ||
                    coli.livreur_id == 'ba30eca4-6a20-4dc3-acc5-fde0735882fb'
                      ? 'uk-text-danger'
                      : (coli.statut == 'attente') &
                        (coli.categorie == 'boutique')
                      ? 'uk-text-primary '
                      : 'uk-text-success'
                  "
                  uk-scrollspy="target: > td; cls:  uk-animation-slide-bottom-small; delay: 150"
                >
                  <td>{{ itemObjKey + 1 }}</td>
                  <td>{{ coli.client_name }}</td>
                  <td>{{ coli.client_phone }}</td>
                  <td>{{ coli.dest_contact }}</td>
                  <td>
                    <span
                      class="uk-margin-small-right uk-text-center"
                      :uk-icon="
                        coli.statut == 'attente'
                          ? 'icon:warning; ratio: 1.5'
                          : 'icon:check; ratio: 1.5'
                      "
                    ></span>
                  </td>
                  <!-- <td>{{ Livreur.name }} F</td> -->
                  <td>{{ coli.valeur }} F</td>
                  <td>{{ coli.montant }} F</td>
                  <td>{{ coli.nature }}</td>
                  <td>
                    {{
                      formatDate(coli.created_at) +
                      " à " +
                      formatHeure(coli.created_at)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, dbstore, auth } from '../../main';
import Swal from "sweetalert2";

export default {
    data(){
        return{
            colis:[],
            coli: {
                nom_boutique: null,
                nom_responsable: null,
                adresse: null,
                contact_boutique: null,
                type_paiement: null,
                adresse_paiement: null
            },
            activeItem:null,
            access : 0
        }
    },

    methods: {
        removeBoutique(key){
            let go = this
            dbstore.collection('boutiques').doc(key).delete()
                .doc(this.$route.params.id)
                .set(this.boutique)
                .then(() => {
                    console.log("Boutique supprimée !");
                    go.$router.push({path:'/admin/boutiques'});
                    Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Boutique supprimée !',
                    showConfirmButton: true,
                    timer: 4000,
                    allowOutsideClick: false,
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },

    created () {
    this.access = this.$store.getters.user.data.role;
    const id = auth.currentUser.uid
    let refSotre
    if(this.access == 5 || this.access == 4 || this.access == 3 || this.access == 2){
    refSotre = dbstore.collection('boutiques')
    }else{
     refSotre = dbstore.collection('boutiques').where('commercial_id', '==', id)
    }
    refSotre.onSnapshot((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.boutiques.push({
            key: doc.id,
            nom_boutique: doc.data().nom_boutique,
            nom_responsable: doc.data().nom_responsable,
            adresse: doc.data().adresse,
            contact_boutique:doc.data().contact_boutique,
            type_paiement:doc.data().type_paiement,
            adresse_paiement:doc.data().adresse_paiement,
            id_proprio:doc.data().id_proprio,
            uuid:doc.data().uuid,
            created_at:doc.data().created_at,
            commercial_id:doc.data().commercial_id
        });
      });

    });

    // created for updateboutique
    var dbstoreRef = dbstore.collection('boutiques').doc(this.$route.params.uuid);
        dbstoreRef
        .get()
        .then((childSnapshot) => {
            const onData = childSnapshot.val();
            this.boutique = onData;
        })
        .catch(() => {
            console.log(dbstoreRef);
        });

  },
}
</script>
<style>
.tilte-tab {
  color: #000000 !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  font-family: "Poppins", sans-serif !important;
}
.livraison {
  font-weight: bold !important;
}
td {
  font-family: "Poppins", sans-serif !important;
  font-size: 0.9em !important;
}
.btn-primary {
  margin-right: 12px;
}
.dateToday {
  padding: 10px;
  border-radius: 20px;
  color: #ffffff !important;
}
.uk-form-width-small {
  background-color: #5dd381 !important;
  color: #ffffff !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  outline: none;
  border-radius: 10px;
  border: none;
}
.uk-label {
  font-size: 0.9em !important;
  font-weight: bold !important;
}
.uk-label:hover {
  background-color: #1f5cdf !important;
}
.uk-label:active {
  background-color: #0c307e !important;
}
</style>

